import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "employees" }
const _hoisted_2 = { class: "employees-card" }
const _hoisted_3 = { class: "employees-header" }
const _hoisted_4 = { class: "employees-title" }
const _hoisted_5 = { class: "employees-actions" }
const _hoisted_6 = {
  key: 0,
  class: "employees-table"
}
const _hoisted_7 = { class: "employees-list-header" }
const _hoisted_8 = { class: "header" }
const _hoisted_9 = { class: "avatar" }
const _hoisted_10 = { class: "fullname" }
const _hoisted_11 = { class: "email" }
const _hoisted_12 = { class: "defaultRole" }
const _hoisted_13 = { class: "defaultHourlyRate" }
const _hoisted_14 = { class: "workDayHours" }
const _hoisted_15 = { class: "region" }
const _hoisted_16 = {
  key: 1,
  class: "loading apollo"
}
const _hoisted_17 = {
  key: 2,
  class: "empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonIcon = _resolveComponent("ButtonIcon")!
  const _component_EntitiesList = _resolveComponent("EntitiesList")!
  const _component_AddEmployees = _resolveComponent("AddEmployees")!
  const _component_EditEmployees = _resolveComponent("EditEmployees")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.t("titles.employees")), 1),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ButtonIcon, {
            label: _ctx.t('buttons.addEmployee'),
            "icon-name": "material-symbols:add",
            onClick: _ctx.showAddModal
          }, null, 8, ["label", "onClick"]),
          (_ctx.selectedEmployees.length > 0)
            ? (_openBlock(), _createBlock(_component_ButtonIcon, {
                key: 0,
                label: _ctx.t('buttons.archiveEmployee'),
                "icon-name": "material-symbols:archive",
                onClick: _ctx.showArchiveModal
              }, null, 8, ["label", "onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.employees.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("ul", _hoisted_7, [
              _createElementVNode("li", _hoisted_8, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "checkbox-placeholder" }, null, -1)),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t("labels.avatar")), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.t("labels.fullname")), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t("labels.email")), 1),
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.t("labels.role")), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.t("labels.defaultHourlyRate")), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t("labels.workDayHours")), 1),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.t("labels.region")), 1)
              ])
            ]),
            _createVNode(_component_EntitiesList, {
              elements: _ctx.employees,
              "has-check-box": true,
              formatters: _ctx.formatters,
              "avatar-column": "avatar",
              checkBoxes: _ctx.checkBoxes,
              "onUpdate:checkBoxes": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkBoxes) = $event)),
              onUpdateCheckBoxes: _ctx.updateCheckBoxes,
              onGoEntityDetails: _ctx.handleEmployeeClick
            }, null, 8, ["elements", "formatters", "checkBoxes", "onUpdateCheckBoxes", "onGoEntityDetails"])
          ]))
        : (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.t("loading")), 1))
          : (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.t("empty.employees")), 1))
    ]),
    (_ctx.isAddModalVisible)
      ? (_openBlock(), _createBlock(_component_AddEmployees, {
          key: 0,
          onClose: _ctx.closeAddModal
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isEditModalVisible && _ctx.selectedEmployee)
      ? (_openBlock(), _createBlock(_component_EditEmployees, {
          key: 1,
          employee: _ctx.selectedEmployee,
          onClose: _ctx.closeEditModal
        }, null, 8, ["employee", "onClose"]))
      : _createCommentVNode("", true)
  ]))
}